import './app.css';
import { mount } from 'svelte';
import App from './App.svelte';
import { platform } from './lib/platform.ts';
import { remote } from './lib/input/remote.ts';
import { primeOnUserGesture } from './lib/player/audioBus.ts';

// Drives the 10-foot overrides in app.css.
document.documentElement.classList.toggle('tv', platform === 'tv');
document.documentElement.dataset.platform = platform;

remote.attach();

// An AudioContext may only start from a user gesture. Arming this at boot means
// tile audio works from the first click or key press, with no extra prompt.
primeOnUserGesture();

// Development only: a handle on the live singletons. Importing the modules from
// the console returns fresh instances through Vite's HMR query, which looks like
// a working app with no players in it.
if (import.meta.env.DEV) {
  void Promise.all([
    import('./lib/player/engine.svelte.ts'),
    import('./lib/player/audioBus.ts'),
  ]).then(([engineModule, audioModule]) => {
    (window as unknown as Record<string, unknown>).__mv = {
      engine: engineModule.engine,
      audio: audioModule,
    };
  });
}

const target = document.getElementById('app');
if (!target) throw new Error('#app fehlt im Dokument');

export default mount(App, { target });
